import { getAlbumTypeList } from "@/api/album";
import { delComment } from "@/api/comments";
import { delMilestone } from "@/api/milestone";
import { del } from "vue";

export default {

    // 用户凭证数据
    TOKEN_KEY: "token",
    USER_INFO_KEY: "userInfo",

    // 常量数据
    BASE_USER_ID: 1,

    // 后端远程服务路径
    BASE_ROOT_URL: "https://124.223.205.191:80",
    // 后端主服务路径
    BASE_URL: "https://liaozhi.site/ginger-cat",
    // BASE_URL: "http://localhost:9050/ginger-cat",
    // 后端文件服务
    BASE_FILE_URL: "https://liaozhi.site/file/",

    /** 游记服务 */
    pubTravelUrl: "/admin/travels-api/createTravel",
    getTravelList: "/travels-api/getTravelList",
    getTravelDetailUrl: "/travels-api/getTravelById",

    /** 弹幕服务 */
    getDanmakuListUrl: "/danmaku-api/getDanmakuList",
    getDanmakuTop20Url: "/danmaku-api/getDanmakuListTop20",
    saveDanmakuUrl: "/danmaku-api/saveDanmaku",
    getAdminDanmakuListUrl: "/danmaku-api/getAdminDanmakuList",
    delUrl: "/danmaku-api/del",

    /** 音乐服务 */
    getMusicList: "/music-api/getMusicList",
    saveMusicUrl: "/admin/music-api/uploadMusic",
    getMusicListByPage: "/admin/music-api/getMusicListByPage",
    delMusicUrl: "/admin/music-api/del",

    /** 配置 */
    getConfigUrl: "/config-api/getConfig",
    updateConfigUrl: "/config-api/updateConfig",

    /** 生活故事服务 */
    // 发布故事
    pubLifeUrl: "/life-api/pubLife",
    getLifeList: "/life-api/getLifeList",
    getLifeDetail: "/life-api/getLifeDetail",
    getArchives: "/life-api/getArchives",
    getLifeListByMonth: "/life-api/getLifeListByMonth",
    getLifeAdminListUrl: "/admin/life-api/getLifeList",
    delLifeUrl: "/admin/life-api/del",
    getLifeTypeListByCountUrl: "/life-api/getLifeTypeListByCount",
    getLifeTypeListUrl: "/life-api/getLifeTypeList",

    // 故事类别
    saveLifeTypeUrl: "/admin/life-api/saveLifeType",
    getLifeTypeListAdminUrl: "/admin/life-api/getAdminLifeTypeList",
    delLifeTypeUrl: "/admin/life-api/delLifeType",

    /** 高德地图服务 */
    // 获取当前用户位置
    getPositionUrl: "/gd-data/getLocalInfo",
    //获取城市编码对应天气
    getWeatherUrl: "/gd-data/getWeatherInfo",


    /** 外链服务 */
    getLinksListUrl: "/links-api/getLinksList",

    /** 数据观测服务 */
    getAnalysisDataUrl: "/analysis-api/getAnalysisData",
    getCountUrl: "/analysis-api/getCount",

    /** 评论服务 */
    saveCommentsUrl: "/comments-api/saveQs",
    getQsListUrl: "/comments-api/getQsList",
    getRecentQsListUrl: "/comments-api/getRecentList",
    getAdminCommentListUrl: "/comments-api/getAdminCommentList",
    delCommentUrl: "/comments-api/del",


    /** 用户服务 */
    // 用户信息
    getUesrInfoUrl: "/user-api/getUserInfoById",
    // 用户登录
    loginUrl: "/user-api/login",
    // 校验token
    verifyTokenUrl: "/user-api/verifyToken",

    /** 里程碑服务 */
    getMilestoneList: "/milestone-api/getMilestoneList",
    getAdminMilestoneList: "/admin/milestone-api/getMilestoneList",
    saveMilestoneInfo: "/admin/milestone-api/saveMilestone",
    delMilestoneUrl: "/admin/milestone-api/del",


    /** 城市历程服务 */
    // 获取城市历程列表
    getCityExperience: "city-experience-api/getCityExperienceList",


    /** 语录服务 */
    // 金句列表
    getCatchphraseUrl: "/catchphrase-api/getCatchphraseList",

    /** 版本服务 */
    getVersionListUrl: "/version-api/getVersionList",


    // 展馆服务
    getAlbumTypeList: "/museum-api/getMuseumTypeList",
    getCuratedAlbumLitUrl: "/museum-api/getCuratedAlbumLit",
    getMuseumDataList: "/museum-api/getMuseumDetailList",
    saveImageSortUrl: "/admin/museum-api/saveCuratedAlbumSort",

    // 保存展馆类别地址
    saveMuseumTypeUrl: "/admin/museum-api/saveMuseumType",
    // 保存展馆详情地址：
    saveMuseumDetailUrl: "/admin/museum-api/saveMuseumDetail",
    getAlbumTypeListUrl: "/admin/museum-api/getAlbumTypeList",
    delAlbumTypeUrl: "/admin/museum-api/delType",
    getAlbumListUrl: "/admin/museum-api/getAlbumList",
    delAlbumUrl: "/admin/museum-api/del",


    /** 工具服务 */
    // 工具数据列表
    getInstrList: "/instr-api/getInstrList",

    /** 工具后台服务 */
    // 保存工具
    saveInstrInfoUrl: "/admin/instr-api/saveInstrInfo",
    getInstrAdminListByPageUrl: "/admin/instr-api/getInstrList",
    delInstrInfoUrl: "/admin/instr-api/del",

    /** 友链服务 */
    saveFriendLinkUrl: "/admin/friends-api/save",
    getFriendListUrl: "/friends-api/getFriendsList",
    getFriendListByPageUrl: "/admin/friends-api/getFriendsList",
    delFriendUrl: "/admin/friends-api/del",

    /** 工具类别后端服务 */
    saveInstrTypeUrl: "/admin/instr-type-api/saveInstrType",
    getInstrTypeListUrl: "admin/instr-type-api/getInstrTypeList",
    getInstrTypeListAdminUrl: "admin/instr-type-api/getAdminInstrTypeList",
    delInstrTypeUrl: "/admin/instr-type-api/del",

    /** 文件服务 */
    // 工具数据列表
    uploadWordToPDf: "/file-api/wordToPdf",
    uploadPdfToWord: "/file-api/pdfToWord",
    uploadFileUrl: "/file-api/uploadFile",
    uploadLifeFileUrl: "/file-api/uploadLifeFile",
    uploadTravelFileUrl: "/file-api/uploadTravelFile",


    /** 后端用户服务 */
    // 更新用户信息
    upUserInfo: "/admin/user-api/updateUserInfo",
    upUserAvatarUrl: "/admin/user-api/upUserAvatar",
    upUserWxUrl: "/admin/user-api/upWx",
    upUserPortraitUrl: "/admin/user-api/upPortrait",
    upUserDrawUrl: "/admin/user-api/upDraw",

    /** 语句后台服务 */
    getCatchphraseAdminListUrl: "/admin/catchphrase-api/getCatchphraseList",
    saveCatchphraseUrl: "/admin/catchphrase-api/saveCatchphrase",
    delCatchphraseUrl: "/admin/catchphrase-api/del",

    /** 城市后端服务 */
    saveCityInfoUrl: "/admin/city-experience-api/saveCityInfo",
}

window.BASE_FILE_URL = "https://liaozhi.site/file/"